module.exports = __webpack_public_path__ + "img/pPx.1fa21329.png";